import React, { useState, useEffect, useRef } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePlp } from '~/contexts/PlpContext'
import { imgSize } from '~/utils/helpers'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/plp/subnav.module.scss"


const Subnav = () => {
  const { isMobile } = useTheme()
  const { collection, onFilter } = usePlp()
  const { subnav } = collection

  const is_big = subnav.big

  const check_view = () => {
    const check = subnav.options.length > (!isMobile ? 4 : 1)
    return check
  }

  const [menu, setMenu] = useState(check_view())
  const itemsRef = useRef(null)
  const backRef = useRef(null)
  const nextRef = useRef(null)

  const check_arrs = () => {
    if (!itemsRef.current || !backRef.current || !nextRef.current) return

    const wrap = itemsRef.current
    const wrap_left = wrap.getBoundingClientRect().left
    const wrap_width = wrap.getBoundingClientRect().width
    const wrap_right = wrap_left + wrap_width
    let items = Array.from(document.querySelectorAll('[subnav]'))
    const last = items[items.length - 1]

    const last_right = last.getBoundingClientRect().left + last.getBoundingClientRect().width
    const scroll = wrap.scrollLeft

    backRef.current.removeAttribute('disabled')
    nextRef.current.removeAttribute('disabled')
    if (scroll < 10) backRef.current.setAttribute('disabled', 'disabled')
    if ((last_right - 1) <= wrap_right) nextRef.current.setAttribute('disabled', 'disabled')
  }

  const handleFilter = (obj) => {
    onFilter(obj);
  }

  const handleClick = (dir) => {
    const next = dir === 'next'
    const total = subnav.options.length - 1
    const change = isMobile ? 1 : 4

    let items = Array.from(document.querySelectorAll('[subnav]'))
    const wrap = itemsRef.current
    const wrap_left = wrap.getBoundingClientRect().left
    const wrap_width = wrap.getBoundingClientRect().width
    let first
    let index
    let offset

    if (next) {
      first = items.find(x => x.getBoundingClientRect().width - wrap_left > 0 )
      index = items.indexOf(first) + change
      if (index > total) index = total
    } else {
      first = items.reverse().find(x => (x.getBoundingClientRect().left + x.getBoundingClientRect().width) < (wrap_left + wrap_width) )
      index = items.indexOf(first) - change
      items.reverse()
      if (index < 0) index = 0
    }
    offset = items[index].getBoundingClientRect().left - wrap_left
    wrap.scrollLeft = offset
  }

  useEffect(() => {
    const check = check_view()
    setMenu(check)
    check_arrs()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return 

    window.addEventListener('resize', check_view, { passive: true })
    return () => {
      window.removeEventListener('resize', check_view)
    }
  })

  useEffect(() => {
    const el = itemsRef.current

    if ( el ) {
      el.addEventListener('scroll', check_arrs, { passive: true })
      return () => {
        el.removeEventListener('scroll', check_arrs)
      }
    }
  })


  return (
    <div className={styles.wrap}>
      {menu && (
        <div className={styles.menu}>
          <div className={styles.title}>
            OUR FITS
          </div>
          <button 
            type="button"
            className={[aria_btn, styles.btn, styles.arrback].join(' ')}
            aria-label="Back"
            ref={backRef}
            onClick={(e)=>{ handleClick('back')} }
          ></button>
          <button 
            type="button"
            className={[aria_btn, styles.btn].join(' ')}
            aria-label="Next"
            ref={nextRef}
            onClick={(e)=>{ handleClick('next')} }
          ></button>
        </div>
      )}
      <div 
        className={`${styles.items} ${menu ? '' : styles.noscroll}`} 
        ref={itemsRef}
        subnav-wr="0"
      >
        {subnav.options.map( (item,index) => {

          const filterObj = {type: item.url.split('=')[0], name: item.url.split('=')[1].replaceAll('_',' ')}

          return (
            <div key={item.title} className={`${styles.item} ${is_big ? styles.big : ''}`} subnav={index}>
              <button 
                type="button"
                className={[aria_btn, styles.img_btn].join(' ')} 
                onClick={(e)=> { handleFilter(filterObj) }}
                aria-pressed="false"
              >
                <img 
                  className={styles.img} 
                  src={imgSize(item.image, is_big ? 900 : 400)}
                  loading="lazy" 
                  alt={item.title}
                />
              </button>
              <button 
                type="button"
                className={[aria_btn, styles.title].join(' ')} 
                onClick={(e)=> { handleFilter(filterObj) }} 
                aria-pressed="false"
              >
                {item.title}
              </button>
              <div className={styles.copy}>
                {item.copy}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Subnav




